import { apiClient } from "../config";

async function archiveOrRestoreBehavior(id: any, status: any) {
  const url = `/admin/behaviors/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreBehavior;
